import { put, takeLatest } from "redux-saga/effects";
import { xetTotNghiepApi } from "../../../api/xet-tot-nghiep/xetTotNghiepApi";
import { IXetTotNghiepRequest } from "../../../model/request/xet-tot-nghiep/IXetTotNghiepRequest";
import { IBaseResponse } from "../../../model/response/IBaseResponse";
import { toLowerCaseDeep } from "../../../utils/toLowerCaseDeep";
import { eXetTotNghiepActionIds, IXetTotNghiepActionTypes } from "../../action-types/xet-tot-nghiep/IXetTotNghiepActions";
import { rootActions } from "../../actions/rootActions";
import { xetTotNghiepPhamViSinhVienApi } from "../../../api/xet-tot-nghiep/xetTotNghiepPhamViSinhVienApi";

export function* xetTotNghiepSaga(): any {
    yield takeLatest(eXetTotNghiepActionIds.XET_START, xetTotNghiepWorker);
    yield takeLatest(eXetTotNghiepActionIds.XET_KET_QUA_HOC_TAP_START, xetKetQuaHocTapWorker);
    yield takeLatest(eXetTotNghiepActionIds.XET_CHUNG_CHI_START, xetChungChiWorker);
    yield takeLatest(eXetTotNghiepActionIds.LOAD_DANH_SACH_XET_START, loadDanhSachXetWorker);
}

function* xetTotNghiepWorker(action: IXetTotNghiepActionTypes) : any {
    const request = action.payload as IXetTotNghiepRequest;
    const response: IBaseResponse = yield xetTotNghiepApi.xetTotNghiep(request, request.progress_id ?? "");
    if (response.is_success) {
        yield put(rootActions.xetTotNghiep.xetTotNghiep.XET_SUCCESS(toLowerCaseDeep(response.message ?? "Xét tốt nghiệp thành công")));
    } else {
        yield put(rootActions.xetTotNghiep.xetTotNghiep.XET_ERROR(response.message ?? "Không thể thực hiện xét tốt nghiệp"));
    }
}

function* xetKetQuaHocTapWorker(action: IXetTotNghiepActionTypes) : any {
    const request = action.payload as IXetTotNghiepRequest;
    const response: IBaseResponse = yield xetTotNghiepApi.xetKetQuaHocTap(request, request.progress_id ?? "");
    if (response.is_success) {
        yield put(rootActions.xetTotNghiep.xetTotNghiep.XET_KET_QUA_HOC_TAP_SUCCESS(toLowerCaseDeep(response.message ?? "Xét kết quả học tập thành công")));
    } else {
        yield put(rootActions.xetTotNghiep.xetTotNghiep.XET_KET_QUA_HOC_TAP_ERROR(response.message ?? "Không thể thực hiện xét kết quả học tập"));
    }
}

function* xetChungChiWorker(action: IXetTotNghiepActionTypes) : any {
    const request = action.payload as IXetTotNghiepRequest;
    const response: IBaseResponse = yield xetTotNghiepApi.xetChungChi(request, request.progress_id ?? "");
    if (response.is_success) {
        yield put(rootActions.xetTotNghiep.xetTotNghiep.XET_CHUNG_CHI_SUCCESS(toLowerCaseDeep(response.message ?? "Xét chứng chỉ thành công")));
    } else {
        yield put(rootActions.xetTotNghiep.xetTotNghiep.XET_CHUNG_CHI_ERROR(response.message ?? "Không thể thực hiện xét chứng chỉ"));
    }
}

function* loadDanhSachXetWorker(action: IXetTotNghiepActionTypes) : any {
    const id_xet_tot_nghiep = action.payload as number;
    const response: IBaseResponse = yield xetTotNghiepPhamViSinhVienApi.SelectAllByDotXet(id_xet_tot_nghiep);
    if (response.is_success) {
        yield put(rootActions.xetTotNghiep.xetTotNghiep.LOAD_DANH_SACH_XET_SUCCESS(toLowerCaseDeep(response.data)));
    } else {
        yield put(rootActions.xetTotNghiep.xetTotNghiep.LOAD_DANH_SACH_XET_ERROR(response.message ?? "Không thể tải danh sách xét tốt nghiệp"));
    }
}